export default "__VITE_ASSET__79f5514c__"